var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-print-none"},[(_vm.$store.getters.isLogged)?_c('MenuLogged'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }